import { ref, computed } from 'vue';

const canShowNotFoundPage = ref(false);

/**
 * Handles the canShowNotFoundPage state responsible for showing the not found page.
 */
export default function useNotFound() {
  /**
   * Performs conditional logic based on SSR vs. client.
   * @param  {object} {reason} a 404 response code is followed by a human-readable "reason phrase".
   */
  function showNotFoundPage({ reason = '' } = {}) {
    if (import.meta.env.SSR) {
      throw {
        status: 404,
        reason: reason || 'Browse page not found',
      };
    } else {
      canShowNotFoundPage.value = true;
    }
  }

  function hideNotFoundPage() {
    canShowNotFoundPage.value = false;
  }

  return {
    canShowNotFoundPage: computed(() => canShowNotFoundPage.value),
    showNotFoundPage,
    hideNotFoundPage,
  };
}
